import { useStoreUser } from '@/stores/user.store'

import { getApiUrl, getBrand } from './brand.util'

const IS_PRODUCTION = process.env.NODE_ENV === 'production'
const APP_VERSION = process.env.NEXT_PUBLIC_MONITORING_TOOL__SERVICE_VERSION

export const makeErrorId = () => {
  const raw =
    typeof crypto !== 'undefined' && 'randomUUID' in crypto
      ? crypto.randomUUID().replace(/-/g, '')
      : `${Date.now().toString(16)}${Math.floor(Math.random() * 1e8).toString(16)}`
  return `MEMO-${raw.slice(0, 8).toUpperCase()}`
}

type ReportOpts = {
  boundary: string
  path?: string
  errorId?: string
}

export const reportClientError = (error: Error & { digest?: string }, opts: ReportOpts) => {
  if (!IS_PRODUCTION || typeof window === 'undefined') return

  try {
    const user = useStoreUser.getState().user
    const payload = {
      name: error.name,
      message: error.message,
      stack: error.stack,
      digest: error.digest,
      errorId: opts.errorId,
      path: opts.path,
      url: window.location.href,
      userAgent: navigator.userAgent,
      language: navigator.language,
      appVersion: APP_VERSION,
      brand: getBrand().website,
      boundary: opts.boundary,
      email: user?.email,
    }

    void fetch(`${getApiUrl()}/api/client-errors`, {
      method: 'POST',
      credentials: 'include',
      keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).catch(() => {})
  } catch (e) {
    void e
  }
}
